export const getValue = (value, question) =>
  value.filter(x => question.id === x.templateQuestionId)
